import { c as _c } from "react/compiler-runtime";
import { Search } from "lucide-react";
import { useState } from "react";
import FieldsetHeader from "@/src/components/tasks/fieldset-header";
import { InputWrapper } from "@/src/components/tasks/input-wrapper";
import { EntityMatcher } from "@/src/components/tasks/intake-sections/matchers";
import { Hyperlink } from "@/src/components/typography";
import { type Address } from "@/src/models/address";
import { locationShape, type Location } from "@/src/models/location";
interface GeocodeLookupSectionProps {
  address: Address | null;
  metadata?: any;
  metadataKey?: string; // e.g., "homeAddress", "receivingLocation.address"
  onUpdate?: (key: string, value: any) => void;
  onSave?: () => void;
  onFlagForInaccuracyUpdate?: (key: string, value: any) => void;
  setMetadata?: (metadata: any) => void;
  clearMetadata?: () => void;
}
export default function GeocodeLookupSection(t0) {
  const $ = _c(82);
  const {
    address,
    metadata,
    metadataKey: t1,
    onUpdate,
    onSave,
    setMetadata,
    clearMetadata
  } = t0;
  const metadataKey = t1 === undefined ? "homeAddress" : t1;
  let t2;
  if ($[0] !== address) {
    t2 = address ? {
      ...locationShape,
      id: "geocode-lookup",
      address
    } : null;
    $[0] = address;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [currentLocation, setCurrentLocation] = useState(t2);
  let t3;
  if ($[2] !== address || $[3] !== onUpdate) {
    t3 = location => {
      if (location && onUpdate) {
        const newAddress = {
          ...address,
          line1: location.address?.line1 || "",
          line2: location.address?.line2 || "",
          city: location.address?.city || "",
          state: location.address?.state || "",
          postalCode: location.address?.postalCode || "",
          placeId: location.placeId || location.address?.placeId || null
        };
        onUpdate("patient.homeAddress", newAddress);
        setCurrentLocation(location);
      }
    };
    $[2] = address;
    $[3] = onUpdate;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleLocationSelect = t3;
  let t4;
  if ($[5] !== onUpdate) {
    t4 = e => {
      e.preventDefault();
      e.stopPropagation();
      setCurrentLocation(null);
      onUpdate?.("patient.homeAddress", null);
    };
    $[5] = onUpdate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleEmptyToggle = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== currentLocation || $[9] !== handleLocationSelect) {
    t6 = <div className="w-[70%]"><EntityMatcher type="location" existingEntities={t5} isLoadingExistingEntities={false} entity={currentLocation} onEntitySelected={handleLocationSelect} showCreateNewOption={false} /></div>;
    $[8] = currentLocation;
    $[9] = handleLocationSelect;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleEmptyToggle) {
    t7 = <div className="flex items-center gap-2"><Hyperlink onClick={handleEmptyToggle} href="#" className="text-xs">Empty</Hyperlink></div>;
    $[11] = handleEmptyToggle;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="flex justify-center items-center mb-4 gap-2">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = address?.line1 || "";
  let t10;
  if ($[16] !== clearMetadata || $[17] !== onSave) {
    t10 = () => {
      clearMetadata?.();
      onSave?.();
    };
    $[16] = clearMetadata;
    $[17] = onSave;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== metadata || $[20] !== metadataKey || $[21] !== setMetadata) {
    t11 = () => setMetadata?.(metadata?.[metadataKey]?.line1_metadata);
    $[19] = metadata;
    $[20] = metadataKey;
    $[21] = setMetadata;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t12 = <InputWrapper value={t9} onChange={_temp} label="Street Address" fieldKey="address.line1" onSave={t10} readOnly={true} onFocus={t11} />;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = address?.line2 || "";
  let t14;
  if ($[27] !== clearMetadata || $[28] !== onSave) {
    t14 = () => {
      clearMetadata?.();
      onSave?.();
    };
    $[27] = clearMetadata;
    $[28] = onSave;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== metadata || $[31] !== metadataKey || $[32] !== setMetadata) {
    t15 = () => setMetadata?.(metadata?.[metadataKey]?.line2_metadata);
    $[30] = metadata;
    $[31] = metadataKey;
    $[32] = setMetadata;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t16 = <InputWrapper value={t13} onChange={_temp2} label="Address Line 2" fieldKey="address.line2" onSave={t14} readOnly={true} onFocus={t15} />;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const t17 = address?.city || "";
  let t18;
  if ($[38] !== clearMetadata || $[39] !== onSave) {
    t18 = () => {
      clearMetadata?.();
      onSave?.();
    };
    $[38] = clearMetadata;
    $[39] = onSave;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== metadata || $[42] !== metadataKey || $[43] !== setMetadata) {
    t19 = () => setMetadata?.(metadata?.[metadataKey]?.city_metadata);
    $[41] = metadata;
    $[42] = metadataKey;
    $[43] = setMetadata;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t17 || $[46] !== t18 || $[47] !== t19) {
    t20 = <InputWrapper value={t17} onChange={_temp3} label="City" fieldKey="address.city" onSave={t18} readOnly={true} onFocus={t19} />;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  const t21 = address?.state || "";
  let t22;
  if ($[49] !== clearMetadata || $[50] !== onSave) {
    t22 = () => {
      clearMetadata?.();
      onSave?.();
    };
    $[49] = clearMetadata;
    $[50] = onSave;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== metadata || $[53] !== metadataKey || $[54] !== setMetadata) {
    t23 = () => setMetadata?.(metadata?.[metadataKey]?.state_metadata);
    $[52] = metadata;
    $[53] = metadataKey;
    $[54] = setMetadata;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t21 || $[57] !== t22 || $[58] !== t23) {
    t24 = <InputWrapper value={t21} onChange={_temp4} label="State" fieldKey="address.state" onSave={t22} readOnly={true} onFocus={t23} />;
    $[56] = t21;
    $[57] = t22;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  const t25 = address?.postalCode || "";
  let t26;
  if ($[60] !== clearMetadata || $[61] !== onSave) {
    t26 = () => {
      clearMetadata?.();
      onSave?.();
    };
    $[60] = clearMetadata;
    $[61] = onSave;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== metadata || $[64] !== metadataKey || $[65] !== setMetadata) {
    t27 = () => setMetadata?.(metadata?.[metadataKey]?.postalCode_metadata);
    $[63] = metadata;
    $[64] = metadataKey;
    $[65] = setMetadata;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t25 || $[68] !== t26 || $[69] !== t27) {
    t28 = <InputWrapper value={t25} onChange={_temp5} label="Zip Code" fieldKey="address.postalCode" onSave={t26} readOnly={true} onFocus={t27} />;
    $[67] = t25;
    $[68] = t26;
    $[69] = t27;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== t20 || $[72] !== t24 || $[73] !== t28) {
    t29 = <div className="grid grid-cols-3 gap-4">{t20}{t24}{t28}</div>;
    $[71] = t20;
    $[72] = t24;
    $[73] = t28;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== t12 || $[76] !== t16 || $[77] !== t29) {
    t30 = <div className="grid grid-cols-1 gap-4 mb-4">{t12}{t16}{t29}</div>;
    $[75] = t12;
    $[76] = t16;
    $[77] = t29;
    $[78] = t30;
  } else {
    t30 = $[78];
  }
  let t31;
  if ($[79] !== t30 || $[80] !== t8) {
    t31 = <div className="space-y-4 mt-4"><FieldsetHeader title="Address Lookup" icon={Search}>{t8}{t30}</FieldsetHeader></div>;
    $[79] = t30;
    $[80] = t8;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  return t31;
}
function _temp5() {}
function _temp4() {}
function _temp3() {}
function _temp2() {}
function _temp() {}